
import ApplicationState from "../../../../../../../ApplicationState"
import IDispatcher from "../../../../../../Util/IDispatcher"
import IState from "../../../../../../Util/IState"
import IndexUI from "./IndexUI"
import ServicesState from "../../State/ServicesState"
import { actionFetchServices } from "../../Actions/ActionCreator"
import IndexDispatch from "./model"
import { Dispatch } from "redux"
import { connect } from "react-redux"
import { ActionType } from "../../Actions/ActionTypes"
import Service from "../../../../../../../dto/Service"

const mapStateToProps = (state: ApplicationState): IState<ServicesState> => {
    return {
        state: state.service
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<IndexDispatch> => ({
    dispatcher: {
        fetch: () => { dispatch(actionFetchServices() as any) },
        selected: (service: Service | undefined) => { dispatch({ type: ActionType.SERVICE_SELECTED, item: service }) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(IndexUI)